var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.status)?_c('div'):_c('v-tooltip',{attrs:{"right":"","z-index":"200"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"ead-status__item",style:({ backgroundColor: _vm.color })},'div',attrs,false),on),[_vm._v(" "+_vm._s(_vm.text)+" ")])]}}])},[_c('div',[_vm._v(_vm._s(_vm.status))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }